import auth0 from 'auth0-js'
import {securityConfig} from '../config/config.js'
import {store} from '../main.js'
import {actions} from './modules/actionsAuth.js'
import {getMedicoByEmail, getMedicoLogueado} from "./services/auth";
import {authenticationCheck} from "./modules/actionsAuth";

/**
* Ema Gomez
* Basado en el quick start de Auth0 que viene para react
*
*/
export default class Auth {
  auth0 = new auth0.WebAuth({
    domain: securityConfig.SECURITY_AUTH0_DOMAIN,
    clientID: securityConfig.SECURITY_AUTH0_CLIENTID,
    redirectUri: securityConfig.SECURITY_AUTH0_REDIRECTURI,
    audience: securityConfig.SECURITY_AUTH0_AUDIENCE,
    responseType: securityConfig.SECURITY_AUTH0_RESPONSETYPE,
    scope: 'openid profile'

  })


  login() {
    if (securityConfig.SECURITY_ENABLED) {
      this.auth0.authorize()
    }
  }

  userHasScopes(scopes) { //Aca en vez de evaluar los scopes pedidos evaluo los que ya tiene en metadata app
    if (securityConfig.SECURITY_ENABLED) {
        const grantedScopes = this.getGrantedScopes()
        if (grantedScopes) {
          return scopes.every(scope => grantedScopes.includes(scope))
        }
        return false
    } else {
      return true
    }
  }

  getGrantedScopes() {
    const grantedScopes = JSON.parse(localStorage.getItem('scopes'))
    return grantedScopes || []
  }

  getUser() {
    if (securityConfig.SECURITY_ENABLED) {
      const userStr = localStorage.getItem('user')
      if(!userStr) {
        throw new Error("No existe usuario, loguearse nuevamente")
      }
      return JSON.parse(userStr)
    } else {
      return {}
    }
  }

  getAccessToken() {
    if (securityConfig.SECURITY_ENABLED) {
          const accessToken = localStorage.getItem('access_token');
          if (!accessToken) {
            return null;
            // throw new Error('No se encontro access token');
          }
          return accessToken;
    } else {
      return "DUMMYACCESSTOKEN"
    }
  }


  constructor() {
    this.login = this.login.bind(this)
    this.logout = this.logout.bind(this)
    this.userHasScopes = this.userHasScopes.bind(this)
    this.getGrantedScopes = this.getGrantedScopes.bind(this)
    this.handleAuthentication = this.handleAuthentication.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
    this.getUser = this.getUser.bind(this)
    this.getAccessToken = this.getAccessToken.bind(this)
    this.parseUser = this.parseUser.bind(this)
    this.getSession = this.getSession.bind(this)
    this.checkSession = this.checkSession.bind(this);
  }

  parseUser(tokenPayload) {
    return {
      name: tokenPayload.name,
      nickname: tokenPayload.nickname,
      email: tokenPayload.email || tokenPayload.name,
      avatar: tokenPayload.picture,
    }
  }

  handleAuthentication(payload) {
    if (!securityConfig.SECURITY_ENABLED) {
      return;
    }
    
    //Valido la autenticacion
    var setSession = this.setSession

    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idTokenPayload) {

        setSession(authResult);
        let user = this.parseUser(authResult.idTokenPayload);
        store.dispatch(actions.authenticationCheck(user));
        // store.dispatch(getMedicoByEmail(user.email))
        store.dispatch(getMedicoLogueado())

        // var auth0Ma = new auth0.Management({
        //   domain: securityConfig.SECURITY_AUTH0_DOMAIN,
        //   token: authResult.idToken
        // })
        //
        // auth0Ma.getUser(authResult.idTokenPayload.sub,function(err, user) {
        //   if  (err) {
        //     throw new Error("no se pudo obtener la metadata del usuario")
        //   }else {
        //     setSession(authResult,user)
        //     store.dispatch(actions.authenticationCheck())
        //   }
        // })


      } else if (err) {
        throw new Error("Error al hacer parseHash"  + err)
      }
    })
  }

  checkSession() {
    let session = this.getSession();

    if (session == null) return null

    setTimeout(()=>{
      store.dispatch(authenticationCheck(this.parseUser(session.data)));
      // store.dispatch(getMedicoByEmail(session.data.email));
      store.dispatch(getMedicoLogueado());
    },10);

    return session;
  }

  setSession(authResult,user) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime())
    const authResultScopes = authResult.scope.split(" ") || ''
    localStorage.setItem('scopes', JSON.stringify(authResultScopes))
    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)
    localStorage.setItem('payload', JSON.stringify(authResult.idTokenPayload))
    // localStorage.setItem('user', JSON.stringify(user))
  }

  getSession() {

    if (!this.isAuthenticated())
      return null;

    let session = {};

    session.scopes = localStorage.getItem('scopes');
    session.data = JSON.parse(localStorage.getItem('payload'));
    session.accessToken = localStorage.getItem('access_token');
    session.expiresAt = localStorage.getItem('expires_at');


    if (session.accessToken && session.data)
      return session;

    return null
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('scopes')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('user')
    localStorage.removeItem('payload')

    //TODO: Descomentar en caso de integrar con auth0
    this.auth0.logout({
      returnTo: window.location.origin
    })
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    if (securityConfig.SECURITY_ENABLED) {
      let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
      return new Date().getTime() < expiresAt
    } else {
      return true  
    }
  }
}



// WEBPACK FOOTER //
// ./src/security/Auth.js